export const DEFAULT_PAGE_SIZE = 16;
export const FAULT_INJECT_INTERNAL_SEARCH = 'faultInject_internalSearch';
export const FAULT_INJECT_FBT = 'faultInject_frequently_bought_together';
export const FAULT_INJECT_JOB_RECOMMENDATIONS =
  'faultInject_job_recommendations';
export const FAULT_INJECT_PARTS_DIAGRAM_LIST = 'faultInject_parts_diagram_list';
export const FAULT_INJECT_INTERNAL_FEDERATED_SEARCH =
  'faultInject_internalFederatedSearch';
export const FAULT_INJECT_GENERIC_ERROR = 'GENERIC_ERROR';
export const FAULT_INJECT_SSO_KITS = 'faultInject_ssoKits';
export const FAULT_INJECT_INTERNAL_PRODUCT_LIST =
  'faultInject_internalProductList';
export const FAULTINJECT_FITMENT_ITEM = 'faultInject_fitmentItem';
